document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-look-form]').forEach(wrapper => {
    const form = wrapper.querySelector('form');
    const hiddenInput = wrapper.querySelector('[data-look-variant-id]');
    const button = wrapper.querySelector('.add-to-cart-button');

    if (!form || !hiddenInput || !button) return;

    const item = wrapper.closest('.look-enterprise__item');
    if (!item) return;

    resetButton();

    item.querySelectorAll('.look-enterprise__variant').forEach(label => {
      const radio = label.querySelector('input');
      const isAvailable = label.dataset.available === 'true';

      radio.addEventListener('change', () => {
        hiddenInput.value = radio.value;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (isAvailable) {
          setButtonAvailable();
        } else {
          setButtonSoldOut();
        }
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (button.hasAttribute('disabled')) return;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(hiddenInput.value),
            quantity: 1
          })
        });

        // 🔄 Atualiza carrinho (Fabric)
        await window.FabricBridge?.refreshCart();

        // 🔥 ANIMAÇÃO REAL DO FABRIC (SEM SELETOR FRÁGIL)
        pulseCartButton();

        // 🧺 Abre drawer
        window.FabricBridge?.openCartDrawer();

      } catch (err) {
        console.error('[Look Enterprise]', err);
      }
    });

    /* ========= FUNÇÕES ========= */

    function resetButton() {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.removeAttribute('data-sold-out');
      setText('Adicionar ao carrinho');
    }

    function setButtonAvailable() {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('data-sold-out');
      setText('Adicionar ao carrinho');
    }

    function setButtonSoldOut() {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('data-sold-out', 'true');
      setText('Esgotado');
    }

    function setText(text) {
      const el = button.querySelector('.add-to-cart-text');
      if (el) el.textContent = text;
    }
  });
});

/* ============================= */
/* CART BUTTON PULSE — BULLETPROOF */
/* ============================= */

function pulseCartButton() {
  // pega QUALQUER botão de carrinho visível no header
  const cartButton =
    document.querySelector('.header-actions__action--cart') ||
    document.querySelector('[aria-label*="Carrinho"]') ||
    document.querySelector('[aria-label*="Cart"]');

  if (!cartButton || !cartButton.animate) return;

  cartButton.animate(
    [
      { transform: 'scale(1)' },
      { transform: 'scale(1.25)' },
      { transform: 'scale(0.95)' },
      { transform: 'scale(1)' }
    ],
    {
      duration: 420,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
  );
}

(function observeCartCounter() {
  let lastValue = null;

  const observer = new MutationObserver(() => {
    const counter = document.querySelector('.cart-bubble__text-count');
    if (!counter || !counter.animate) return;

    const value = counter.textContent.trim();
    if (!value || value === lastValue) return;

    lastValue = value;

    // 🔑 cancela animações antigas sem reset visual
    counter.getAnimations().forEach(anim => anim.cancel());

    // 🔥 animação estilo Fabric (desce e encaixa, SEM piscar)
    requestAnimationFrame(() => {
      counter.animate(
        [
          {
            transform: 'translateY(-6px) scale(0.95)'
          },
          {
            transform: 'translateY(0) scale(1)'
          }
        ],
        {
          duration: 220,
          easing: 'cubic-bezier(0.2, 0.6, 0.2, 1)'
        }
      );
    });
  });

  function start() {
    const bubble = document.querySelector('.cart-bubble');
    if (!bubble) return requestAnimationFrame(start);

    observer.observe(bubble, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  start();
})();
